import React from 'react';
import clsx from 'clsx';
import i18n from '../../../../i18n';
import { FormControl, FormControlLabel, Radio, RadioGroup, RadioProps } from '@material-ui/core';
import { WrappedFieldProps } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';

export const DELIVERY_PROVIDER = {
    SHOP: 'SHOP',
    APISHIP: 'APISHIP',
};

const useStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 20,
        height: 20,
        backgroundColor: 'rgba(15, 24, 37, 0.1)',
        'input:hover ~ &': {
            backgroundColor: 'rgba(15, 24, 37, 0.2)',
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#243143',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 20,
            height: 20,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#243143',
        },
    },
});

function StyledRadio(props: RadioProps) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export const DeliveryRadioButtonsField = ({ input, ...rest }: WrappedFieldProps | any) => {
    const { t } = i18n.useTranslation();
    return (
        <FormControl>
            <RadioGroup row {...input} {...rest}>
                <FormControlLabel
                    value={DELIVERY_PROVIDER.SHOP}
                    control={<StyledRadio />}
                    label={t('onboarding:settings:deliveryCard:shopRadioButton')}
                />
                <FormControlLabel
                    value={DELIVERY_PROVIDER.APISHIP}
                    control={<StyledRadio />}
                    label={t('onboarding:settings:deliveryCard:apishipRadioButton')}
                />
            </RadioGroup>
        </FormControl>
    );
};
